import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const scanIp = async (userId, scan_uuid, scan_type) => {
  if (!userId || !scan_uuid) {
    throw {
      message: "User ID and Agent UUID are required",
      code: "INVALID_INPUT",
      card: false
    };
  }

  if (!scan_uuid) {
    throw {
      message: "Agent UUID is required",
      code: "INVALID_INPUT",
      card: false
    };
  }

  try {
    const token = sessionStorage.getItem('authToken');
    if (!token) {
      throw {
        message: "Authentication token is missing",
        code: "UNAUTHORIZED",
        card: false
      };
    }

    const response = await fetch(
      `${api_base_url}/api/${api_key}/post/${userId}/network/scanIp`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ scan_uuid, scan_type })
      }
    );

    const data = await response.json();
    if (!response.ok || data.success === false) {
      throw {
        message: data.message || "Request failed",
        code: data.code || "UNKNOWN_ERROR",
        card: data.meta?.showUpgradeCard || false
      };
    }

    return data;
  } catch (error) {
    console.error('Error posting user IP:', error.message);
    throw {
      message: error.message || "Network error",
      code: error.code || "NETWORK_ERROR",
      card: error.card || false
    };
  }
};

export const scanNIp = async (userId, scan_uuid) => {
  if (!userId || !scan_uuid) {
    throw {
      message: "User ID and Agent UUID are required",
      code: "INVALID_INPUT",
      card: false
    };
  }

  try {
    const token = sessionStorage.getItem('authToken');
    if (!token) {
      throw {
        message: "Authentication token is missing",
        code: "UNAUTHORIZED",
        card: false
      };
    }

    const response = await fetch(
      `${api_base_url}/api/${api_key}/post/${userId}/network/scanNIp`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ scan_uuid })
      }
    );

    const data = await response.json();
    if (!response.ok || data.success === false) {
      throw {
        message: data.message || "Request failed",
        code: data.code || "UNKNOWN_ERROR",
        card: data.meta?.showUpgradeCard || false
      };
    }

    return data;
  } catch (error) {
    console.error('Error posting user IP:', error.message);
    throw {
      message: error.message || "Network error",
      code: error.code || "NETWORK_ERROR",
      card: error.card || false
    };
  }
};
